document.addEventListener('DOMContentLoaded', function () {
  const toggleButtons = document.querySelectorAll('.drawer__nav-toggle-btn');

  toggleButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();

      const targetId = button.getAttribute('data-target');
      const targetElement = document.querySelector(targetId);

      if (targetElement) {
        targetElement.classList.toggle('show');
        button.classList.toggle('collapsed');
        const isExpanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', !isExpanded);
      }
    });
  });
});
